// Types
import { SHORT_NAME } from '../../../../packages/constants/nameTypes';
import { ITennisConfig, ITennisMatch, ITennisMatchProgrammeList, SDKDateOptions } from '../../../../packages/types';

// Constants
import { normalizeTennisMatchData } from './normalizeTennisMatchData';
import { normalizeRoundData } from './normalizeTennisRoundData';

interface INormalizeTennisTournamentProgrammeResponseDataArgs {
  matchesList?: ITennisMatchProgrammeList[];
  dataEntityLinks?: ITennisConfig['dataEntityLinks'];
  dataShortStatusType?: ITennisConfig['dataShortStatusType'];
  dataLabels?: ITennisConfig['dataLabels'];
  sdkDateOptions?: SDKDateOptions;
}

export const normalizeTennisProgrammeResponseData = ({
  matchesList,
  dataLabels,
  dataEntityLinks,
  sdkDateOptions,
}: INormalizeTennisTournamentProgrammeResponseDataArgs) => {
  if (!matchesList || matchesList?.length < 1) return;

  const normalizedResponseData = matchesList?.map(({ round, matches }) => {
    const normalizedMatches = matches?.map((match: ITennisMatch) =>
      normalizeTennisMatchData({
        match: match,
        dataEntityLinks,
        dataShortStatusType: SHORT_NAME,
        sdkDateOptions,
      }),
    );

    const normalizedRound = normalizeRoundData({ round, dataLabels });
    return { matches: normalizedMatches, round: normalizedRound };
  });

  return normalizedResponseData;
};
